<template>
  <div class="sinos-legenda">
    <div class="col-md-8 offset-md-4">
      <div class="div-legenda-monitoramento col-md-3 offset-3">
        <img
          src="../../assets/images/icone-bell-2.png"
          class="monitoria-sim"
          alt="Completamente Monitorado"
        />
        <span>
          Completamente
          <br />Monitorado
        </span>
      </div>
      <div class="div-legenda-monitoramento col-md-3">
        <img
          src="../../assets/images/icone-bell-3.png"
          class="monitoria-sim"
          alt="Parcialmente Monitorado"
        />
        <span>
          Parcialmente
          <br />Monitorado
        </span>
      </div>
      <div class="div-legenda-monitoramento col-md-3">
        <img
          src="../../assets/images/icone-bell-1.png"
          class="monitoria-sim"
          alt="Não Monitorado"
        />
        <span>
          Não
          <br />Monitorado
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SinosLegenda"
};
</script>

<style lang="scss" scoped>
.sinos-legenda {
  margin-top: 10px;
}
</style>
